import styled, {css, keyframes} from "styled-components";

/**
 * Connection UI components for linking assembly nodes
 */
export const AssemblyConnections = {
    ConnectionList: styled.div`
      margin-top: 10px;
      border-top: 1px solid #e2e8f0;
      padding-top: 10px;
      display: flex;
      flex-direction: column;
      gap: 6px;
    `,
    ConnectionRow: styled.div`
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      padding: 6px 8px;
      font-size: 13px;
      color: #0f172a;
    `,
    ConnectionForm: styled.div`
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 8px;
      margin-top: 10px;
      align-items: center;
    `,
    ConnectionSvg: styled.svg`
      position: absolute;
      inset: 0;
      pointer-events: none;
      overflow: visible;
    `,
    ConnectionPath: styled.path<{ $active: boolean, $speed: number }>`
      stroke: ${props => props.$active ? "#22c55e" : "#3b82f6"};
      stroke-width: 4;
      fill: none;
      filter: drop-shadow(0 2px 6px rgba(59, 130, 246, 0.5));
      stroke-dasharray: ${props => props.$active ? "8 10" : "none"};
      ${props => props.$active ? css`
        animation: ${keyframes`
          from { stroke-dashoffset: 0; }
          to { stroke-dashoffset: -32px; }
        `} ${Math.max(0.6, 2.5 - Math.min(props.$speed, 5) * 0.25)}s linear infinite;
      ` : ""};
      opacity: ${props => props.$active ? 1 : 0.85};
    `,
    DragLine: styled.line`
      stroke: #22c55e;
      stroke-width: 4;
      fill: none;
      pointer-events: none;
      opacity: 0.9;
      filter: drop-shadow(0 0 4px rgba(34, 197, 94, 0.5));
    `,
};
